const JSONKeyValueRegExp = /"(.+?)": "(.+?)",?$/gm;
const prettyStringfy = (obj: Record<string, unknown>): string => JSON.stringify(obj, null, 2);
function getFirstGroup(regexp: RegExp, str: string) {
  const array = [...str.matchAll(regexp)];
  const firstGroup = array.map((m) => m[1]).filter((v) => v !== undefined);
  if (firstGroup.length > 0) return firstGroup;
  return null;
}
function getSecondGroup(regexp: RegExp, str: string) {
  const array = [...str.matchAll(regexp)];
  const secondGroup = array.map((m) => m[2]).filter((v) => v !== undefined);
  if (secondGroup.length > 0) return secondGroup;
  return null;
}
export const getObjectValuesToArray = (obj: Record<string, unknown>): string[] | null =>
  getSecondGroup(JSONKeyValueRegExp, prettyStringfy(obj));

export const getObjectKeysToArray = (obj: Record<string, unknown>): string[] | null =>
  getFirstGroup(JSONKeyValueRegExp, prettyStringfy(obj));
